import { PaymentType } from 'consts/consts';

import en from './strings.en';

const ru = {
    needAuth: 'Необходимо авторизоваться',
    forbidWriteOff: 'Отсутствует доступ к работе с виртуальным счётом. Пожалуйста, обратитесь к руководителю.',
    popup: {
        title: 'Выберите способ оплаты',
        remaining: 'Доступ будет открыт до {{date}}, 23:59 — еще {{hours}} ч. {{minutes}} мин.',
        cancel: 'Отмена',
        [PaymentType.payByBankCard]: {
            priceInfo: 'С вашей карты спишется {{price}}\u00A0₽ за доступ к Поиску активных перевозчиков — оплата происходит на сайте партнёра.\nИскать исполнителей можно сразу после оплаты.',
            confirm: 'Оплатить',
        },
        [PaymentType.payFromVirtualAccount]: {
            priceInfo: 'С вашего счёта спишется {{price}}\u00A0атисов за доступ к Поиску активных перевозчиков. Искать исполнителей можно сразу после оплаты.',
            confirm: 'Оплатить',
        },
        [PaymentType.topUpVirtualAccount]: {
            priceInfo: 'Вы сможете оплатить услугу после того, как атисы поступят на счёт.',
            confirm: 'Купить атисы',
        },
        atises: {
            withBalance: {
                title: 'Атисами',
                description: 'с вашего счёта'
            },
            withoutBalance: {
                title: 'Купить атисы',
                description: 'через р\\с, наличные, моб. платёж'
            }
        },
        bankCard: 'Банковская карта',
    },
    accessPayed: 'Доступ уже оплачен'
};

export default { ru, en: { ...ru, ...en} };
